import type { PagesLoginSource } from "@glide/auth-controller-core";
import { SecondaryLabelWrapper } from "../custom-sign-in/custom-wire-sign-in/secondary-label-wrapper";
import { getLocalizedString } from "@glide/localization";

interface Props extends React.PropsWithChildren {
    readonly pagesSource?: PagesLoginSource;
    readonly onPageSourceChanged?: (newPageSource: PagesLoginSource) => void;
}

export const SignUpFooter: React.VFC<Props> = p => {
    const { pagesSource, onPageSourceChanged } = p;
    const showSignUpFooter = pagesSource === "modal-sign-in" || pagesSource === "modal-sign-up";
    const descriptionText =
        pagesSource === "modal-sign-in"
            ? getLocalizedString("dontHaveAnAccount")
            : getLocalizedString("alreadyHaveAnAccount");
    const actionText =
        pagesSource === "modal-sign-in" ? getLocalizedString("signUp") : getLocalizedString("customerLogIn");
    const action =
        pagesSource === "modal-sign-in"
            ? () => onPageSourceChanged?.("modal-sign-up")
            : () => onPageSourceChanged?.("modal-sign-in");

    return (
        <>
            {showSignUpFooter && (
                <div tw="flex items-center justify-center text-sm mt-6">
                    <SecondaryLabelWrapper>
                        <span>{descriptionText}</span>
                        <span className="secondary" tw="font-medium pl-1 cursor-pointer" onClick={action}>
                            {actionText}
                        </span>
                    </SecondaryLabelWrapper>
                </div>
            )}
        </>
    );
};
